export default __webpack_public_path__ + "static/media/2.c5e0c4f7.jpg";